/**
 * The Thread mark — the brand logo. A wavy line from a sage dot (candidate) to a coral dot
 * (referee). Copied verbatim from design-spec/01-foundations.md. Inline stroke SVG, no icon font.
 *
 * The gradient needs a document-unique id: this mark renders more than once per page here (shell
 * header + loading states), and duplicate SVG ids make every instance resolve to the first.
 */
import { useId } from 'react';

export function ThreadMark({ className }: { className?: string }) {
  const gradientId = useId();
  return (
    <svg
      viewBox="0 0 34 20"
      width={34}
      height={20}
      className={className}
      role="img"
      aria-label="By My Word"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#7A9278" />
          <stop offset=".5" stopColor="#E7A987" />
          <stop offset="1" stopColor="#D9704A" />
        </linearGradient>
      </defs>
      <path
        d="M2 12 C 8 2, 14 18, 17 10 C 20 2, 26 18, 32 6"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth={2.4}
        strokeLinecap="round"
      />
      <circle cx="2" cy="12" r="3" fill="#7A9278" />
      <circle cx="32" cy="6" r="3" fill="#D9704A" />
    </svg>
  );
}
